<template>
    <div>
        <v-sheet
            color="white"
            :outlined="true"
            height="50"
            width="100%">
                <div class="d-flex bottom-border" >
                    <v-icon>mdi mdi-paperclip</v-icon>
                    <v-chip
                        v-for="(doc, index) in docs" :key="index"
                        class="ma-1"
                        filter>
                        {{ doc.nombre }}
                    </v-chip>
                </div>
        </v-sheet>
    </div>
</template>
<script>
export default {
    props: [
        'docs'
    ]
}
</script>
<style scoped>
.bottom-border {
    border-bottom: solid 1px;
}
</style>